import {
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  CardHeader,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./style/theme";

const freeFeatures = [
  "Real-time cost benchmarking vs industry peers",
  "Interactive savings potential dashboard",
  "Expert optimization roadmap consultation",
  "Secure read-only access - zero infrastructure risk",
];

const paidFeatures = [
  "Intelligent discount and reservation management",
  "Comprehensive financial reporting and analytics",
  "Enterprise-grade security with minimal access",
];

const PricingCard = ({
  title,
  subheader,
  features,
  buttonText,
  buttonColor,
}) => (
  <Card
    sx={{
      height: "100%",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "white",
    }}
  >
    <CardHeader
      title={title}
      subheader={subheader}
      titleTypographyProps={{ variant: "body1", fontWeight: "bold" }}
      subheaderTypographyProps={{ variant: "subtitle2", color: "primary.main" }}
      sx={{ bgcolor: "grey.200" }}
    />
    <CardContent sx={{ flexGrow: 1 }}>
      <List disablePadding>
        {features.map((item, index) => (
          <ListItem key={index} disableGutters>
            <ListItemIcon>
              <DoneIcon color="secondary" />
            </ListItemIcon>
            <ListItemText
              primaryTypographyProps={{
                fontSize: "1rem", // change to desired size
                fontWeight: 500, // optional
              }}
              primary={item}
            />
          </ListItem>
        ))}
      </List>
    </CardContent>
    <CardActions sx={{ p: 2 }}>
      <Button
        variant="contained"
        fullWidth
        size="large"
        sx={{ backgroundColor: buttonColor }}
      >
        {buttonText}
      </Button>
    </CardActions>
  </Card>
);

export default function Pricing() {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ py: 8, bgcolor: "background.paper" }}>
        <Container maxWidth="lg">
          <Box textAlign="center" sx={{ mb: 6 }}>
            <Typography
              variant="h3"
              sx={{ fontWeight: "bold", mb: 1.5, color: "primary.main" }}
            >
              Cut Cloud Costs, Maximize Efficiency.
            </Typography>
            <Typography
              variant="inherit"
              color="text.secondary"
              sx={{ maxWidth: 850, mx: "auto" }}
            >
              Awsmo automatically optimizes your cloud infrastructure and
              delivers guaranteed savings through intelligent cost management
              and real-time monitoring.
            </Typography>
          </Box>

          <Grid
            container
            spacing={10}
            alignItems="stretch"
            justifyContent="center"
          >
            <Grid item xs={12} md={6}>
              <PricingCard
                title="Cloud Cost Analysis"
                subheader="Free"
                features={freeFeatures}
                buttonText="Get Free Analysis"
                buttonColor="primary.main"
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PricingCard
                title="Awsmo Platform"
                subheader="Performance-Based Savings"
                features={paidFeatures}
                buttonText="Contact Sales Team"
                buttonColor="secondary.main"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
